export type PptSelectionMode = "auto" | "preset" | "custom";

export const PPT_AUDIENCE_AUTO_VALUE = "__auto__";
export const PPT_AUDIENCE_CUSTOM_VALUE = "__custom__";
export const PPT_AUDIENCE_PRESETS = [
  "政府/主管部门/国企",
  "客户/甲方/采购方/合作方",
  "投资人/股东",
  "企业管理层/决策层",
  "内部团队/员工",
  "公众/媒体",
] as const;

export const PPT_AUDIENCE_OPTIONS = [
  { value: PPT_AUDIENCE_AUTO_VALUE, label: "自动判断" },
  ...PPT_AUDIENCE_PRESETS.map((value) => ({ value, label: value })),
  { value: PPT_AUDIENCE_CUSTOM_VALUE, label: "自定义" },
] as const;

export const DEFAULT_PPT_AUDIENCE = "";

export function normalizePptAudienceSelection(value: unknown, mode: unknown): { mode: PptSelectionMode; audience: string } {
  const audience = typeof value === "string" ? value.trim().slice(0, 1_000) : "";
  if (mode === "auto" || audience === PPT_AUDIENCE_AUTO_VALUE) return { mode: "auto", audience: "" };
  if (mode === "custom" || audience === PPT_AUDIENCE_CUSTOM_VALUE) {
    return { mode: "custom", audience: audience === PPT_AUDIENCE_CUSTOM_VALUE ? "" : audience };
  }
  if (mode === "preset" || PPT_AUDIENCE_PRESETS.includes(audience as (typeof PPT_AUDIENCE_PRESETS)[number])) {
    return PPT_AUDIENCE_PRESETS.includes(audience as (typeof PPT_AUDIENCE_PRESETS)[number])
      ? { mode: "preset", audience }
      : { mode: "auto", audience: "" };
  }
  // Persisted legacy values and URL-provided free text are retained as custom
  // selections instead of being silently replaced by an unrelated preset.
  return audience ? { mode: "custom", audience } : { mode: "auto", audience: "" };
}

export function pptAudienceSelectValue(mode: PptSelectionMode, audience: string): string {
  return mode === "auto" ? PPT_AUDIENCE_AUTO_VALUE : mode === "custom" ? PPT_AUDIENCE_CUSTOM_VALUE : audience;
}
